import React, { useEffect } from "react";
import { Button, Modal } from "react-bootstrap";

function ConfirmPopUp({show, handleClose, handleConfirm, title, message, proceedCaption, cancelCaption}) {
    useEffect(() => {
        const handleKeyDown = (e) => {
          if (e.key === "Enter" && show) {
            e.preventDefault(); // Prevent form submission or default behavior
            handleConfirm();    // Trigger confirm handler
          }
        };
    
        document.addEventListener("keydown", handleKeyDown);
    
        return () => {
          document.removeEventListener("keydown", handleKeyDown);
        };
      }, [show, handleConfirm]);
    
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span dangerouslySetInnerHTML={{ __html: message }} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {cancelCaption}
                </Button>
                <Button variant="danger" onClick={handleConfirm}>
                    {proceedCaption}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}


export default ConfirmPopUp;